import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { CategoryGamesProvider, useCasinoNewState, useCategoryGamesState } from '@atlas/core';
import { Loader, useViewportObserverContext } from '@atlas/ui';

import { CasinoCategory } from 'components/Pages/Casino/CasinoCategory';
import { useCasinoFilterState } from 'components/Pages/Casino/CasinoFilterContext';
import { GAME_SIZES, GROUPS } from 'components/Pages/Casino/constants';
import GameList from 'components/Pages/Casino/GameList/GameList';
import { casinoFilterTypeMap, deleteCasinoFilter } from 'components/Pages/Casino/useCasinoFilter';

const LobbyAnyCategoriesBlockContent = ({ categoryId, setActiveItem }) => {
  const { group } = useCasinoNewState();
  const { categoryGames, loading } = useCategoryGamesState();
  const { updateFilter } = useCasinoFilterState();
  const viewportObserverRef = useViewportObserverContext();

  const category = useMemo(() => {
    if (!categoryId) return null;
    return categoryGames.find(cat => String(cat.id) === String(categoryId));
  }, [categoryGames, categoryId]);

  const sliderSettings = useMemo(() => {
    if (group === GROUPS.LIVE) {
      return { rows: 1, size: GAME_SIZES.SMALL };
    }
    return { rows: 1, size: GAME_SIZES.MEDIUM };
  }, [group]);

  const showCategoryHandler = useCallback(
    id => () => {
      updateFilter({ providerNames: [] });
      deleteCasinoFilter(casinoFilterTypeMap.providerNames);
      setActiveItem(id.toString());
      viewportObserverRef.current?.scrollTo(0, 0);
    },
    [setActiveItem, updateFilter, viewportObserverRef],
  );

  if (loading) {
    return (
      <div className="casino-lobby__item">
        <Loader />
      </div>
    );
  }

  if (!category) {
    return null;
  }

  return (
    <div className="casino-lobby__item">
      <CasinoCategory
        InfoGamesList={GameList}
        games={category.games}
        iconUrl={category.iconUrl}
        id={category.id}
        name={category.name}
        showCategoryHandler={showCategoryHandler}
        sliderSettings={sliderSettings}
      />
    </div>
  );
};

LobbyAnyCategoriesBlockContent.propTypes = {
  categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setActiveItem: PropTypes.func,
};

const LobbyAnyCategoriesBlock = ({ categoryId, setActiveItem }) => {
  const { group } = useCasinoNewState();

  return (
    <CategoryGamesProvider gamesCount={20} group={group}>
      <LobbyAnyCategoriesBlockContent categoryId={categoryId} setActiveItem={setActiveItem} />
    </CategoryGamesProvider>
  );
};

LobbyAnyCategoriesBlock.propTypes = {
  categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setActiveItem: PropTypes.func,
};

export default LobbyAnyCategoriesBlock;
